module.exports = __webpack_public_path__ + "img/hangxin.115499e0.png";